import { Injectable } from '@angular/core';
import { ExtensionCommunicationService } from '@shared/extension';
import { AbstractStudentStore } from './abstract';

@Injectable()
export class StudentStore extends AbstractStudentStore {
  constructor(protected extensionCommunicationService: ExtensionCommunicationService) {
    super(extensionCommunicationService);
  }
}
